import { E as ERROR_CUSTOMER_NOT_AUTHORIZED, a as ERROR_CART_SESSION_EXPIRED, b as ERROR_CART_NOT_ACTIVE, c as ERROR_CART_ID_NOT_FOUND, d as ERROR_CART_CANNOT_PERFORM_OPERATIONS } from './serverErrors-O6unZmFR.js';

const CART_INVALID_ERROR_MESSAGES = [
    ERROR_CUSTOMER_NOT_AUTHORIZED,
    ERROR_CART_SESSION_EXPIRED,
    ERROR_CART_NOT_ACTIVE,
    ERROR_CART_ID_NOT_FOUND,
    ERROR_CART_CANNOT_PERFORM_OPERATIONS,
];

export { CART_INVALID_ERROR_MESSAGES as C };
//# sourceMappingURL=cart-AU0vdOfm.js.map
